/**
 * The bell tower above the western terrace (lifted from lantern-water's
 * `world.js` `createTown`, its `atElevation(w, 1.4, ...)` block): a plaster
 * shaft on a stone plinth with cornice bands, pilasters with quoins, a clock
 * (the face has hour ticks, no numerals: no text is painted), an arched bell
 * opening with its bell, and a slate roof. Origin at the tower's centre (the
 * prototype's x 1, z -14.2); the placement stands it 1.4 up. No params. Its
 * collider is the scene record's.
 */
import * as THREE from 'three';
import { clockTexture } from '../art.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'bell_tower',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { box, cylinder, mesh, roof, archShape, m, kit } = ctx;
    const dz = 14.2;
    box(root, 0, 5.15, 0, 2.5, 8.3, 2.5, m.plaster);
    box(root, 0, 2, 0, 2.7, 2, 2.7);
    for (const y of [4.5, 7.6, 8.7]) box(root, 0, y, 0, 2.72, 0.16, 2.72, m.cream);
    for (const xx of [-1.16, 1.16]) {
      box(root, xx, 5.3, -12.88 + dz, 0.2, 7.2, 0.18, m.cream);
      for (let i = 0; i < 12; i += 1) box(root, xx, 2.1 + i * 0.56, -12.86 + dz, 0.3, 0.16, 0.23, m.stone);
    }
    mesh(root, kit.shared('bell-tower:rim', () => new THREE.TorusGeometry(0.76, 0.09, 5, 36)), m.cream, 0, 5.95, -12.79 + dz);
    const face = kit.shared('bell-tower:clock', () => new THREE.MeshStandardMaterial({ map: kit.shared('bell-tower:clock-face', clockTexture), roughness: 1 }));
    mesh(root, kit.shared('bell-tower:dial', () => new THREE.CircleGeometry(0.71, 36)), face, 0, 5.95, -12.775 + dz);
    mesh(root, new THREE.ExtrudeGeometry(archShape(1.13, 1.62), { depth: 0.08, bevelEnabled: false }), m.cream, 0, 7.92, -12.9 + dz);
    mesh(root, new THREE.ShapeGeometry(archShape(0.88, 1.35), 10), m.dark, 0, 7.92, -12.805 + dz);
    box(root, 0, 8.19, -12.7 + dz, 0.73, 0.1, 0.18, m.darkWood);
    cylinder(root, 0, 7.94, -12.65 + dz, 0.08, 0.47, m.brass);
    cylinder(root, 0, 7.66, -12.63 + dz, 0.27, 0.38, m.brass, 0.42);
    cylinder(root, 0, 7.47, -12.63 + dz, 0.31, 0.08, m.brass);
    roof(root, 0, 9.2, 0, 2.8, 3, 2, m.roofDark);
    return { root };
  },
};
